import { Eye } from "lucide-react";

/** Shown in a route hero when the current user has view-only (no-write) access. */
export function ViewOnlyBadge() {
  return (
    <span className="border-border text-muted-foreground inline-flex items-center gap-1.5 rounded-lg border bg-[oklch(1_0_0_/_0.04)] px-3 py-2.5 text-[11px] font-medium tracking-[0.12em] uppercase">
      <Eye className="size-3.5" />
      View only
    </span>
  );
}
